import CustomerId                 from "../../../../domain/customer/CustomerId";
import Count                      from "../../../../domain/fundamentals/count/Count";
import Date                       from "../../../../domain/fundamentals/date/Date";
import FetchStatusRepository      from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository           from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import CurrentPage                from "../../../../domain/fundamentals/pagination/CurrentPage";
import Pagination                 from "../../../../domain/fundamentals/pagination/Pagination";
import TotalPage                  from "../../../../domain/fundamentals/pagination/TotalPage";
import CustomerRecord             from "../../../../domain/record/customer/CustomerRecord";
import CustomerRecordId           from "../../../../domain/record/customer/CustomerRecordId";
import CustomerRecordRepository   from "../../../../domain/record/customer/CustomerRecordRepository";
import CustomerRecords            from "../../../../domain/record/customer/CustomerRecords";
import CustomerRecordTemplate     from "../../../../domain/record/customer/CustomerRecordTemplate";
import CustomerRecordWidget       from "../../../../domain/record/customer/widget/CustomerRecordWidget";
import CustomerRecordWidgetId     from "../../../../domain/record/customer/widget/CustomerRecordWidgetId";
import CustomerRecordWidgets      from "../../../../domain/record/customer/widget/CustomerRecordWidgets";
import CustomerRecordWidgetItem   from "../../../../domain/record/customer/widget/item/CustomerRecordWidgetItem";
import CustomerRecordWidgetItemId from "../../../../domain/record/customer/widget/item/CustomerRecordWidgetItemId";
import CustomerRecordWidgetItems  from "../../../../domain/record/customer/widget/item/CustomerRecordWidgetItems";
import RecordTemplateId           from "../../../../domain/record/template/RecordTemplateId";
import RecordTemplateName         from "../../../../domain/record/template/RecordTemplateName";
import RecordTemplateRevision     from "../../../../domain/record/template/RecordTemplateRevision";
import WidgetItemId               from "../../../../domain/record/widget/item/WidgetItemId";
import WidgetItemTitle            from "../../../../domain/record/widget/item/WidgetItemTitle";
import WidgetItemValue            from "../../../../domain/record/widget/item/WidgetItemValue";
import WidgetCoordinate           from "../../../../domain/record/widget/WidgetCoordinate";
import WidgetId                   from "../../../../domain/record/widget/WidgetId";
import WidgetTitle                from "../../../../domain/record/widget/WidgetTitle";
import WidgetTypeClass            from "../../../../domain/record/widget/WidgetTypeClass";
import WidgetValue                from "../../../../domain/record/widget/WidgetValue";
import FetchStatusDataSource      from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource           from "../../../../infrastructure/datasource/notify/NotifyDataSource";
import CustomerRecordDataSource   from "../../../../infrastructure/datasource/record/customer/CustomerRecordDataSource";

class GetCustomerRecords {
  private readonly customersRecordRepository: CustomerRecordRepository = new CustomerRecordDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);

  constructor(
    private readonly dispatch,
  ) {
  }

  public async execute(customerId: CustomerId, current: CurrentPage) {
    this.fetchStatusRepository.start();
    try {
      const response = await this.customersRecordRepository.findByPage(customerId, current);
      const list: CustomerRecord[] = response.data.customer_records.map(customerRecord => (
        new CustomerRecord(
          new CustomerRecordId(customerRecord.id),
          Date.ofText(customerRecord.date),
          new CustomerRecordTemplate(
            new RecordTemplateId(customerRecord.template.id),
            new RecordTemplateRevision(customerRecord.template.revision),
            new RecordTemplateName(customerRecord.template.name),
            new CustomerRecordWidgets(
              customerRecord.template.widgets.map(widget => (
                new CustomerRecordWidget(
                  new CustomerRecordWidgetId(widget.id),
                  new WidgetId(widget.widgetiId),
                  new WidgetTypeClass(widget.type),
                  new WidgetCoordinate(widget.coordinate.x, widget.coordinate.y),
                  new WidgetTitle(widget.title),
                  new WidgetValue(widget.value),
                  new CustomerRecordWidgetItems(
                    widget.items.map(item => (
                      new CustomerRecordWidgetItem(
                        new CustomerRecordWidgetItemId(item.id),
                        new WidgetItemId(item.widgetItemId),
                        new WidgetItemTitle(item.title),
                        new WidgetItemValue(item.value)
                      )
                    ))
                  )
                )
              ))
            )
          )
        )
      ));
      const pagination: Pagination = new Pagination(new CurrentPage(response.data.pagination.current), new TotalPage(response.data.pagination.total));
      const count: Count = new Count(response.data.count);
      const customerRecords: CustomerRecords = new CustomerRecords(list, pagination, count);
      this.customersRecordRepository.setCustomerRecords(customerRecords);
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetCustomerRecords;
